import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { Button } from "@mui/material";
import { connect } from "react-redux";
import LandingScreenHeader from "../../components/Comman/LandingScreenHeader";
import tableStyles from "../../Styles/csvImportingValidation";

const OutletTargetImportValidationTable = ({
    onClickOfExport,
    onClickOfImport,
    searchValue,
    onSearchBox,
    getFilteredTableData,
    validatedProductList,
}) => {

    return (
        <>
            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                }}
            >
                <LandingScreenHeader
                    screenTitle="Outlet Target Import"
                    showSaveBtnMain={false}
                    showAddButton={false}
                    showBackButton={false}
                />

                <div style={{ display: "flex", gap: 15 }}>
                    <Button
                        variant="outlined"
                        color="secondary"
                        size="medium"
                        startIcon={<CloudDownloadIcon />}
                        sx={{
                            borderRadius: 2,
                            textTransform: "none",
                            fontWeight: 600,
                            transition: "all 0.2s",
                            minWidth: "120px",
                            height: "35px",
                            "&:hover": {
                                backgroundColor: "#f4f6fa",
                                borderColor: "#1976d2",
                                color: "#1976d2",
                                transform: "translateY(-2px)",
                            },
                        }}
                        onClick={onClickOfExport}
                    >
                        Export
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        size="medium"
                        startIcon={<CloudUploadIcon sx={{ color: "#fff" }} />}
                        sx={{
                            color: "#fff",
                            borderRadius: 2,
                            textTransform: "none",
                            fontWeight: 600,
                            transition: "all 0.2s",
                            minWidth: "150px",
                            height: "35px",
                            "&:hover": {
                                backgroundColor: "#1976d2",
                                transform: "translateY(-2px)",
                            },
                        }}
                        onClick={onClickOfImport}
                    >
                        Import
                    </Button>
                </div>
            </div>
            <br />
            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "5px",
                }}
            >
                {/* Search Box */}
                <input
                    type="text"
                    placeholder="Search..."
                    value={searchValue}
                    onChange={onSearchBox}
                    style={{
                        padding: "6px 10px",
                        fontSize: "14px",
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                        width: "230px",
                    }}
                />
            </div>

            <div style={tableStyles.tableWrapper}>
                <table style={tableStyles.table}>
                    <thead style={tableStyles.stickyHeader}>
                        <tr style={tableStyles.headerRow}>
                            <th
                                style={{ ...tableStyles.headerCell, minWidth: "60px" }}
                            >
                                Sr.No
                            </th>
                            <th
                                style={{
                                    ...tableStyles.headerCell,
                                    minWidth: "50px",
                                    textAlign: "left",
                                }}
                            >
                                Outlet Name
                            </th>

                            <th
                                style={{
                                    ...tableStyles.headerCell,
                                    minWidth: "50px",
                                    textAlign: "center",
                                }}
                            >
                                Outlet Code
                            </th>

                            <th
                                style={{
                                    ...tableStyles.headerCell,
                                    minWidth: "50px",
                                    textAlign: "center",
                                }}
                            >
                                From Date
                            </th>

                            <th
                                style={{
                                    ...tableStyles.headerCell,
                                    minWidth: "50px",
                                    textAlign: "center",
                                }}
                            >
                                To Date
                            </th>

                            <th
                                style={{
                                    ...tableStyles.headerCell,
                                    minWidth: "50px",
                                    textAlign: "right",
                                }}
                            >
                                Target Amt
                            </th>

                            <th
                                style={{
                                    ...tableStyles.headerCell,
                                    minWidth: "90px",
                                    textAlign: "left",
                                }}
                            >
                                Error Message
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {validatedProductList.length !== 0 &&
                            getFilteredTableData(validatedProductList).map(
                                (row, index) => {

                                    const message = row.errorMsgs.join(", ");

                                    return (
                                        <tr
                                            key={index + 1
                                            }
                                            style={{
                                                ...tableStyles.dataRow,
                                                ...tableStyles.alternateRow,
                                                ...(index % 2 === 0
                                                    ? tableStyles.alternateRow
                                                    : {}),
                                                ...(row.flag == 1 && { backgroundColor: "#ed8e98" }),
                                            }}
                                            onMouseEnter={(e) => {
                                                e.currentTarget.style.backgroundColor =
                                                    tableStyles.dataRowHover.backgroundColor;
                                            }}
                                            onMouseLeave={(e) => {
                                                e.currentTarget.style.backgroundColor =
                                                    row.flag == 1
                                                        ? "#ed8e98"
                                                        : index % 2 === 0
                                                            ? tableStyles.alternateRow.backgroundColor
                                                            : tableStyles.dataRow.backgroundColor;
                                            }}
                                        >
                                            <td
                                                style={{
                                                    ...tableStyles.dataCell,
                                                    minWidth: "60px",
                                                    textAlign: "center",
                                                }}
                                            >
                                                {index + 1}
                                            </td>
                                            <td
                                                style={{
                                                    ...tableStyles.dataCell,
                                                    minWidth: "80px",
                                                    textAlign: "left",
                                                }}
                                            >
                                                {row?.outletName || "-"}
                                            </td>

                                            <td
                                                style={{
                                                    ...tableStyles.dataCell,
                                                    minWidth: "50px",
                                                    textAlign: "center",
                                                }}
                                            >
                                                {row?.outletCode || "-"}
                                            </td>

                                            <td
                                                style={{
                                                    ...tableStyles.dataCell,
                                                    minWidth: "50px",
                                                    textAlign: "center",
                                                }}
                                            >
                                                {row?.fromDate || "-"}
                                            </td>

                                            <td
                                                style={{
                                                    ...tableStyles.dataCell,
                                                    minWidth: "50px",
                                                    textAlign: "center",
                                                }}
                                            >
                                                {row?.toDate || "-"}
                                            </td>

                                            <td
                                                style={{
                                                    ...tableStyles.dataCell,
                                                    minWidth: "50px",
                                                    textAlign: "right",
                                                }}
                                            >
                                                {row?.amount.toFixed(2) || "-"}
                                            </td>

                                            {row.flag == 1 ? (
                                                <td
                                                    style={{
                                                        ...tableStyles.dataCell,
                                                        minWidth: "90px",
                                                        textAlign: "left",
                                                    }}
                                                >
                                                    {message || "-"}
                                                </td>
                                            ) : (
                                                <td
                                                    style={{
                                                        ...tableStyles.dataCell,
                                                        minWidth: "90px",
                                                        textAlign: "left",
                                                    }}
                                                >
                                                    {"-"}
                                                </td>
                                            )}
                                        </tr>
                                    )
                                }
                            )}

                        {validatedProductList.length === 0 && (
                            <tr>
                                <td colSpan="18" style={tableStyles.noData}>
                                    No Data found
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div >
        </>
    );
};
const mapStateToProps = (state) => ({});

const mapDispatchToProps = {
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(OutletTargetImportValidationTable);
